const path =
    <>
        <p>
            I went through significant changes in my close relationships this past summer, sending me
            down a rabbit hole where all I could wonder was what love — romantic and platonic alike — is
            supposed to look like. All this reflection reminded me of a short video I produced as part of my high
            school senior thesis on the repercussions of challenging the status quo, as portrayed in <em>The God of
                Small Things</em> by Arundhati Roy.
            <br />
            <br />
            Two characters in the novel dared to break code by loving one another outside of their respective castes,
            bringing into question both the simplicity and complexity of love. Having had difficulty understanding, let
            alone expressing, this profundity, I candidly asked some of my closest friends what love meant to them. The
            wildly different conversations that ensued made me realize that the intricacy of love lies in just that —
            every one had something different to say, and all of their definitions of love hinged on their own personal
            experiences.
            <br />
            <br />
            <iframe width="560" height="315" src="https://www.youtube.com/embed/spLo7hHzCCg" frameBorder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen id="video" title="define your own love"></iframe>
            <br />
            <i>The video for which I’d eventually asked my friends to summarize our talks,
                effectively doing a third of the intellectual work for this project :) Thanks, guys!</i>
            <br />
            <br />
            While this video is about love in particular, the fundamental message of defining your own path rings true
            for life in all regards. Nearly four years after completing this thesis, I’ve yet truly to curb my fears and
            anxieties in straying from the path that seemingly all my peers are calmly strolling down. I’d arrived on
            campus as a freshman believing my lingering indecision about my area of study and career path would be
            acceptable and even commonplace, but I found myself surrounded by people who knew (or seemed to know)
            exactly what they wanted out of and after the university experience.
            <br />
            <br />
            Fast forward a couple semesters later and I found myself captivated by the idea of marrying my burgeoning
            interest in tech with my lifelong goals of uplifting the underrepresented communities around me. But alas,
            while my friends had all been becoming more and more integrated into the computer science department and the
            industry beyond, I’d been taking classes in various sparsely-connected subjects, spurred by that same,
            unchanging indecision.
            <br />
            <br />
            To this day on my bad days, the voice in my head scolds me for not having followed the same trajectory as
            other students had. It humiliates me for being so irresolute at 18 years old. It reprimands me
            because I’d prioritized exploring miscellaneous topics of interest instead of just sticking with a major and
            following that career path.
            <br />
            <br />
            On my good days, however, that voice is a lot kinder. It reassures me that, all while I was harboring fears
            about having to pave my own path, I’d been doing that very same task anyway. It insists that comparing my
            academic and career timeline to those of my friends is like comparing apples to oranges: erroneous,
            nonsensical, and counterproductive. It reminds me that I have decided on a major that I thoroughly enjoy, I
            am more able to articulate what I want from projects and experiences, and, most importantly, I know and hold
            dear to my heart the positive social impact I want to impart to my community.
            <br />
            <br />
            The intricacy of life lies in the fact that each one of us has only one to live, and no other person gets to
            live that same one. I understand that this sentiment may be trite to some, but such a realization genuinely
            has been eye-opening for me. Rather than think of it as an arduous chore, I now regard finding my
            own way and having my own experiences as an invaluable opportunity. When I started to appreciate the
            diversity of humanity, I stopped to envy other people’s experiences and started to appreciate my own. And
            while indecision, anxiety, and fear don’t elude me completely, I remain unfazed — I know what’s important to
            me, and that’s the best compass one could ask for.
        </p>
    </>;

export default path;